import { hasPreference } from '@/assets/js/helpers/index.js'

export default {
    filterIsActive: (state, getters, rootState) => {
        return state.defaultFilterCardStatus.length !== state.filterCardStatus.length || state.defaultFilterCardStatus.every(function(value, index) {
            return value !== state.filterCardStatus[index];
        })
    },
}